import { compact, concat, isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import { IMappedLocationGroupDaypart } from 'src/interfaces';

export const useActionBar = (
  sortTableData: IMappedLocationGroupDaypart[],
  headers: string[],
) => {
  const [csvData, setCsvData] = useState<any>([]);

  useEffect(() => {
    // Define the data as an array of arrays, each representing a row
    const data = [
      compact(headers), // Add headers as the first row

      sortTableData.map((item) =>
        concat(
          [
            item.startDate,
            item.endDate,
            item.daypartName, // Ensure Daypart is always a string
            item.assemblyName,
            item.scheduledOrDefault,
            item.assemblyScheduleDate,
          ],
          headers.includes('Override')
            ? [!isEmpty(item.scheduleOverrides) ? 'Yes' : 'No']
            : [],
        ),
      ),
    ];

    setCsvData([...data[1]]);
  }, [headers, sortTableData]);

  return {
    csvData,
  };
};
